export enum SortCodeType {
  Property = 'property',
  Income = 'income',
  Regular = 'regular'
}
